<!-- 向屏显发布广告 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode": "PR2WCYG4",
                "ytjId": "3571F003",
                "refreshType": 0,
                "time": 0,
                "data": [{
                        "line": 1,
                        "type": 0,
                        "color": "#FF0000",
                        "content": "第一行文字"
                    },
                    {
                        "line": 2,
                        "type": 0,
                        "color": "#FF0000",
                        "content": "第二行文字"
                    },
                    {
                        "line": 3,
                        "type": 2,
                        "content": "http://127.0.0.1/1.jpg|http://127.0.0.1/2.jpg"
                    }
                ]
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台对连接到云端的LCD屏下发屏显广告。",
                t_url: this.commonUrls.test+"cloudLCDAd",
                p_url: this.commonUrls.prod+"cloudLCDAd",
                precondition: "",
                fitSystem: "云停车场，VEMS传统停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'ytjId', info2: '否', info3: 'Long', info4: '云车场一体机ID，云车场必填' },
                        { info1: 'customCode', info2: '否', info3: 'String', info4: 'vems通道自定义编码，vems车场必填' },
                        { info1: 'refreshType', info2: '是', info3: 'Integer', info4: '屏幕切换类型。0固定（永久显示） 1动态（显示一定时间后，切回默认屏显）' },
                        { info1: 'time', info2: '否', info3: 'Integer', info4: '触发屏显必填，单位:秒。默认30秒，触发屏显如果在该值内连续下发，则显示新的触发屏显，时间以新的配置重新开始计算时间' },
                        { info1: 'data', info2: '是', info3: 'JSONArray', info4: '屏显内容' },
                        ]
                }, {
                    titleName: 'data',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'line', info2: '是', info3: 'Integer', info4: '行号，从1开始' },
                        { info1: 'type', info2: '是', info3: 'Integer', info4: '内容类型,0字符串 1二维码 2图片' },
                        { info1: 'color', info2: '否', info3: 'String', info4: '文字颜色,内容类型为0时必填，格式:"#FF0000"' },
                        { info1: 'content', info2: '是', info3: 'String', info4: '内容,设置默认屏显的图片时，多张图片之间用”|”分隔' },
                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/cloud/cloudLCDAd.vue